(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-portfolio-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-portfolio-experience')) {
  customElements.define('ms-portfolio-experience', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.querySelector('.ms-portfolio');
      if (!this.root) return;
      this.stage = 0; this.paused = false; this.frame = 0;
      this.query = matchMedia('(prefers-reduced-motion: reduce)');
      this.short = matchMedia('(max-height:850px) and (max-width:700px)');
      this.dialog = this.querySelector('dialog');
      const opts = {signal:this.abort.signal};
      this.root.classList.add('is-enhanced');
      this.onClick = (event) => {
        const target = event.target.closest('button,a');
        if (!target || !this.contains(target)) return;
        if(target.closest('.stage-controls')) {
          const index=[...this.querySelectorAll('.stage-controls button')].indexOf(target);
          this.setStage(index);
          if(!this.staticMode) {
            const rect=this.querySelector('.sequence').getBoundingClientRect();
            scrollTo({top:scrollY+rect.top-this.top+(rect.height-innerHeight+this.top)*[.08,.49,.88][index],behavior:'smooth'});
          }
        } else if(target.matches('.hotspot')) this.openStory(3,target);
        else if(target.matches('.gallery-card')) this.openStory([...this.querySelectorAll('.gallery-card')].indexOf(target),target);
        else if(target.hasAttribute('data-close')) this.dialog.close();
        else if(target.matches('.motion-control')) {this.paused=!this.paused;this.updateMotion();}
        else if(target.getAttribute('href')?.startsWith('#ms-')) {
          const dest=this.querySelector(target.getAttribute('href'));
          if(dest){event.preventDefault();scrollTo({top:scrollY+dest.getBoundingClientRect().top-this.top-74,behavior:this.staticMode?'instant':'smooth'});}
        }
      };
      this.addEventListener('click',this.onClick,opts);
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},opts);
      this.dialog.addEventListener('close',()=>this.trigger?.focus({preventScroll:true}),opts);
      this.query.addEventListener('change',()=>this.updateMotion(),opts);
      this.short.addEventListener('change',()=>this.updateMotion(),opts);
      const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
      addEventListener('scroll',schedule,{...opts,passive:true});
      addEventListener('resize',()=>{this.measure();schedule()},opts);
      this.measure();this.updateMotion();
    }
    measure(){
      const header=document.querySelector('.shopify-section-header-sticky');
      this.top=header?header.getBoundingClientRect().height:0;
      this.root.style.setProperty('--ms-top',this.top+'px');
    }
    updateMotion(){
      this.staticMode=this.query.matches||this.short.matches||this.paused;
      this.root.classList.toggle('motion-off',this.staticMode);
      const button=this.querySelector('.motion-control');
      button.setAttribute('aria-pressed',String(this.paused));
      button.disabled=this.query.matches;
      button.querySelector('span').textContent=this.querySelector(this.staticMode?'[data-motion-off]':'[data-motion-on]').content.textContent;
      this.querySelector('.sequence-hint').textContent=this.querySelector(this.staticMode?'[data-hint-static]':'[data-hint-scroll]').content.textContent;
      this.update();
    }
    setStage(index){
      if(index<0||index>2)return;
      this.stage=index;
      this.querySelector('.stage-visual').dataset.stage=String(index);
      this.querySelectorAll('.stage-layer').forEach((el,i)=>{el.classList.toggle('is-current',i===index);el.setAttribute('aria-hidden',String(i!==index));});
      this.querySelector('.stage-copy').replaceChildren(this.querySelector(`[data-perspective="${index}"]`).content.cloneNode(true));
      this.querySelector('.stage-count').firstChild.textContent='0'+(index+1);
      this.querySelectorAll('.stage-controls button').forEach((el,i)=>el.setAttribute('aria-pressed',String(i===index)));
    }
    update(){
      const hero=this.querySelector('.hero').getBoundingClientRect();
      const rect=this.querySelector('.sequence').getBoundingClientRect();
      const progress=Math.max(0,Math.min(1,(this.top-rect.top)/Math.max(1,rect.height-innerHeight+this.top)));
      const hp=Math.max(0,Math.min(1,-hero.top/Math.max(1,hero.height*.75)));
      this.root.style.setProperty('--hero-progress',this.staticMode?'0':String(hp));
      this.root.style.setProperty('--sequence-progress',String(progress));
      const index=progress<.32?0:progress<.66?1:2;
      if(!this.staticMode&&index!==this.stage)this.setStage(index);
      const ids=['overview','featured','details','contact'];
      const active=[...ids].reverse().find(id=>this.querySelector('#ms-'+id).getBoundingClientRect().top<=innerHeight*.4)||'overview';
      this.querySelectorAll('.nav-links a').forEach(a=>{if(a.getAttribute('href')==='#ms-'+active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
    }
    openStory(index,trigger){
      this.trigger=trigger;
      this.dialog.replaceChildren(this.querySelector(`[data-story="${index}"]`).content.cloneNode(true));
      this.dialog.showModal();this.dialog.querySelector('[data-close]').focus();
    }
    disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);if(this.dialog?.open)this.dialog.close();}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-scroll-forge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-scroll-forge')) {
    customElements.define(
      'ms-scroll-forge',
      class MsScrollForge extends HTMLElement {
        connectedCallback() {
          this.scenes = Array.from(this.querySelectorAll('[data-ms-forge-scene]'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.ticking = false;
          this.handleUpdate = this.requestUpdate.bind(this);
          this.handleMotionChange = this.configureMotion.bind(this);
          this.reducedMotion.addEventListener('change', this.handleMotionChange);
          this.configureMotion();
        }

        disconnectedCallback() {
          this.disableScroll();
          this.reducedMotion.removeEventListener('change', this.handleMotionChange);
        }

        configureMotion() {
          this.disableScroll();
          if (this.reducedMotion.matches) {
            this.style.setProperty('--ms-forge-progress', 1);
            this.activateScene(this.scenes.length - 1);
            return;
          }
          window.addEventListener('scroll', this.handleUpdate, { passive: true });
          window.addEventListener('resize', this.handleUpdate);
          this.update();
        }

        disableScroll() {
          window.removeEventListener('scroll', this.handleUpdate);
          window.removeEventListener('resize', this.handleUpdate);
        }

        requestUpdate() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        }

        update() {
          const distance = Math.max(this.offsetHeight - window.innerHeight, 1);
          const progress = Math.min(Math.max(-this.getBoundingClientRect().top / distance, 0), 1);
          const sceneIndex = Math.min(Math.floor(progress * this.scenes.length), this.scenes.length - 1);
          this.style.setProperty('--ms-forge-progress', progress.toFixed(4));
          this.activateScene(sceneIndex);
        }

        activateScene(index) {
          this.scenes.forEach((scene, sceneIndex) => {
            scene.classList.toggle('is-active', sceneIndex === index);
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
